import axios from "axios";
import { Producer } from "../models";

export const getProducers = async () => {
    const response = await axios.get<Producer[]>("/producers");
    return response;
}